export default class Functions {
    static getEndPoint() {
        return (window.location.hostname == 'localhost') ? 'http://localhost:5000' : 'https://api-bg-tennis-01.web.app';
    }

    static getPlatformKey() {
        return '27cebb8eb365aaeccfbfcf9e02334296b4b3ae0a616c371098d1ed420ffbeca598ec1d8454f84e34a3d7dbfeac77629f';
    }
}